@let details = volunteerDetails();
@let canCoordinateVolunteers = dialogDataService.canCoordinateVolunteers();

@if(details?.mentorSchedule; as mentorSchedule) {
<schedule-viewer-part [userType]="'Volunteer'" [meetings]="mentorSchedule" [timeZoneId]="details.standardFourTimeZoneId"
	[canEdit]="canCoordinateVolunteers" (saved)="dialogDataService.reloadData()">
</schedule-viewer-part>
} @else {

<common-message alertType='info'>
	@if(!canCoordinateVolunteers){
	No Schedule added for this Volunteer
	} @else if(!details?.isMentorApproved){
	This Volunteer is not Approved as a Mentor and has no existing Schedule. If you would like to add one for them, please mark them as an Approved Mentor first.
	} @else if(!details?.mentorSchedule){
	This Mentor has not created a schedule. Would you like to fill it out on their behalf?
	}
</common-message>

@if(details?.isMentorApproved && canCoordinateVolunteers){
<common-button-row [center]="true" class="mt-3">
	<button class="btn btn-standard" (click)="addMeetings()">Add Schedule</button>
</common-button-row>
}
}